import { SxProps, useTheme } from '@mui/material';
import { flexCenter } from '../../../commonUI/cssClasses';

/**
 * A hook that returns common styles to be shared across forms (this was created to avoid code duplication and to be able to use useTheme bc with simple constants we wouldn't have access to the theme).
 * @returns {object} An object containing the styles for the form
 */
const useFormStyles = () => {
  const theme = useTheme();

  const commonStyles: SxProps = {
    width: '100%',
    color: theme.colors.common.white,
  };

  const commonTextFieldStyles: SxProps = {
    ...commonStyles,
    '& .MuiInputBase-input': {
      color: theme.colors.common.white, // Text color
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.colors.darkTheme.grey.light, // Underline color
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.colors.darkTheme.grey.muted, // Underline color on hover
    },
    // Prevents the box from turning white if autofill is used
    '& .MuiInputBase-input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0 100px ${theme.colors.darkTheme.grey.dark} inset`,
      WebkitTextFillColor: 'white',
    },
    '& .MuiInputBase-input:-webkit-autofill:focus': {
      WebkitBoxShadow: `0 0 0 100px ${theme.colors.darkTheme.grey.dark} inset`,
      WebkitTextFillColor: 'white',
    },
  };

  const commonFormSectionStyles: SxProps = {
    width: '100%',
    ...flexCenter,
    m: '0.5rem 0',
  };

  return {
    commonStyles,
    commonTextFieldStyles,
    commonFormSectionStyles,
  };
};

export default useFormStyles;
